import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { ImagePreviewComponent } from "../../LR-management/image-preview/image-preview.component";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-add-vechile",
  templateUrl: "./add-vechile.component.html",
  styleUrls: ["./add-vechile.component.css"],
})
export class AddVechileComponent implements OnInit {
  vehicletypes;
  driver;
  vehicleTypesNames = [];
  DriverNames = [];
  filteredVehicleTypes: Observable<string[]>;
  filteredDriverName: Observable<string[]>;
  fileSource: string[] = [];
  @ViewChild("showSlip") showSlip: ElementRef;
  apiUrl = environment.domain;
  slipURL: any;
  permitPreview: any;
  rcPreview: any;
  insuracePreview: any;
  permit5yPreview: any;
  roadTexPreview: any;
  fitnessPreview: any;
  ownerpanPreview: any;
  owneradharPreview: any;
  cancelledChequePreview: any;
  fieldsUploaded: any = {
    permit: null,
    RCCopy: null,
    insurance: null,
    permitYears: null,
    roadTax: null,
    fitness: null,
    ownerPancard: null,
    ownerAadharCard: null,
    cancelledCheque: null,
  };
  addNewVehicle = new FormGroup({
    vehicleNumber: new FormControl("", [Validators.required]),
    vehicleType: new FormControl("", [Validators.required]),
    transporter: new FormControl(null),
    ownership: new FormControl("", [Validators.required]),
    // ownerName: new FormControl(""),
    driverName: new FormControl(""),
    makerName: new FormControl(""),
    chassisNumber: new FormControl(""),
    engineNumber: new FormControl(""),
    permitNumber: new FormControl(""),
    policyNumber: new FormControl(""),
    city: new FormControl(""),
    permitDueDate: new FormControl(""),
    permitYearsDueDate: new FormControl(""),
    purchaseDate: new FormControl(""),
    roadTaxDate: new FormControl(""),
    insuranceDueDate: new FormControl(""),
    fitnessDueDate: new FormControl(""),
    pollutionExpiryDate: new FormControl(""),
    permit: new FormControl(""),
    RCCopy: new FormControl(""),
    insurance: new FormControl(""),
    permitYears: new FormControl(""),
    roadTax: new FormControl(""),
    fitness: new FormControl(""),
    ownerPancard: new FormControl(""),
    ownerAadharCard: new FormControl(""),
    cancelledCheque: new FormControl(""),
  });
  filteredTransporterList: Observable<any[]>;
  transporterNames: any[] = [];
  transporterList: any[] = [];

  get ff() {
    return this.addNewVehicle.controls;
  }

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.getDriverName();
    this.getVehicleType();
    this.getTransporters();
  }

  private _filterTransporter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.transporterNames.filter((name) =>
      name.toLowerCase().includes(filterValue),
    );
  }

  getTransporters() {
    this.superAdminService.getTransportersDropdownList().subscribe((res) => {
      if (res.status) {
        this.transporterList = res.data;

        this.filteredTransporterList = this.ff.transporter.valueChanges.pipe(
          startWith(""),
          map((value) => this.filterTransporter(value || "")),
        );
      }
    });
  }

  filterTransporter(value: string) {
    const filterValue = value.toLowerCase();

    return this.transporterList.filter((t) =>
      t.full_name.toLowerCase().includes(filterValue),
    );
  }

  onSelectTransporter(transporter) {
    this.addNewVehicle.patchValue({
      transporter: transporter,
    });
  }

  displayTransporter(t): string {
    return t ? t.full_name : "";
  }

  getDriverName() {
    this.superAdminService.getDriverName().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.driver = rawdata;
          this.driver.forEach((item) => {
            if (item.driver_name) {
              this.DriverNames.push(item.driver_name);
            }
          });
          this.filteredDriverName = this.ff.driverName.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterDriverName(value || "")),
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {},
    );
  }

  private _filterDriverName(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.DriverNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  getVehicleType() {
    this.superAdminService.getVehicleType().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.vehicletypes = rawdata;
          this.vehicletypes.forEach((item) => {
            this.vehicleTypesNames.push(item.vehicletype_name);
          });
          this.filteredVehicleTypes = this.ff.vehicleType.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterVehicleType(value || "")),
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {},
    );
  }

  private _filterVehicleType(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.vehicleTypesNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  resetimg(image: any) {
    switch (image) {
      case "permit":
        this.permitPreview = "";
        break;
      case "rc":
        this.rcPreview = "";
        break;
      case "insurance":
        this.insuracePreview = "";
        break;
      case "permit5y":
        this.permit5yPreview = "";
        break;
      case "roadtax":
        this.roadTexPreview = "";
        break;
      case "fitness":
        this.fitnessPreview = "";
        break;
      case "ownerpan":
        this.ownerpanPreview = "";
        break;
      case "owneradhar":
        this.owneradharPreview = "";
        break;
      case "cancheck":
        this.cancelledChequePreview = "";
        break;
      default:
        break;
    }
  }

  // fileChangeEventPermit(fileInput: any) {
  //   const file = fileInput.target.files[0];
  //   if (!file) return;

  //   this.fieldsUploaded["permit"] = file;

  //   const reader = new FileReader();

  //   reader.onload = () => {
  //     this.permitPreview = {
  //       url: reader.result,
  //       type: file.type,
  //     };
  //   };

  //   reader.readAsDataURL(file);
  // }

  // fileChangeEventRC(fileInput: any) {
  //   const file = fileInput.target.files[0];
  //   if (!file) return;

  //   this.fieldsUploaded["RCCopy"] = file;
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.rcPreview = { url: reader.result, type: file.type };
  //   };
  // }

  // fileChangeEventInsurance(fileInput: any) {
  //   this.fieldsUploaded["insurance"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.insuracePreview = reader.result;
  //   };
  // }

  // fileChangeEventPermitYears(fileInput: any) {
  //   this.fieldsUploaded["permitYears"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.permit5yPreview = reader.result;
  //   };
  // }

  // fileChangeEventRoadTax(fileInput: any) {
  //   this.fieldsUploaded["roadTax"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.roadTexPreview = reader.result;
  //   };
  // }

  // fileChangeEventFitness(fileInput: any) {
  //   this.fieldsUploaded["fitness"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.fitnessPreview = reader.result;
  //   };
  // }

  // fileChangeEventOwnerPancard(fileInput: any) {
  //   this.fieldsUploaded["ownerPancard"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.ownerpanPreview = reader.result;
  //   };
  // }

  // fileChangeEventOwnerAadharcard(fileInput: any) {
  //   this.fieldsUploaded["ownerAadharCard"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.owneradharPreview = reader.result;
  //   };
  // }

  // fileChangeEventCancelledCheque(fileInput: any) {
  //   this.fieldsUploaded["cancelledCheque"] = fileInput.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = () => {
  //     this.cancelledChequePreview = reader.result;
  //   };
  // }

  addNewVehicleSubmit() {
    if (this.addNewVehicle.invalid) {
      this.toastr.error("Please fill all required fields.");
      return;
    }

    const form = this.addNewVehicle.value;
    const fieldKeys = Object.keys(this.fieldsUploaded);
    const fieldValues = Object.values(this.fieldsUploaded);

    const formData = new FormData();
    formData.append("myFormData", JSON.stringify(form));
    formData.append("updatedFields", JSON.stringify(fieldKeys));

    fieldValues.forEach((file: any) => {
      formData.append("uploads[]", file);
    });

    this.spinner.show();
    this.superAdminService.addVehicle(formData).subscribe({
      next: (res: { status: boolean; message: string }) => {
        this.spinner.hide();
        if (res.status) {
          this.toastr.success(res.message);
          this.router.navigate(["/superAdmin/manageVehicle"]);
        } else {
          this.toastr.error(res.message);
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error("Something went wrong! Please contact support.");
      },
    });
  }

  preview(field) {
    let file = this.fieldsUploaded[field];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type,
        )
      ) {
        this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: file },
        });
      } else {
        let url = URL.createObjectURL(file);
        this.slipURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showSlip.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload document");
    }
  }

  resetForm() {
    this.addNewVehicle.reset();
    this.fieldsUploaded = {
      permit: null,
      RCCopy: null,
      insurance: null,
      permitYears: null,
      roadTax: null,
      fitness: null,
      ownerPancard: null,
      ownerAadharCard: null,
      cancelledCheque: null,
    };
  }

  backTo() {
    window.history.back();
  }

  addvalidatorcss(id: string) {
    document.getElementById(id).classList.add("validatorcss");
  }

  removevalidatorcss(id: string) {
    document.getElementById(id).classList.remove("validatorcss");
  }

  handleFileUpload(event: any, key: string, previewKey: string) {
    const file = event.target.files[0];
    if (!file) return;

    this.fieldsUploaded[key] = file;

    this[previewKey] = {
      url: URL.createObjectURL(file),
      type: file.type,
      name: file.name,
    };
  }

  fileChangeEventPermit(e: any) {
    this.handleFileUpload(e, "permit", "permitPreview");
  }

  fileChangeEventRC(e: any) {
    this.handleFileUpload(e, "RCCopy", "rcPreview");
  }

  fileChangeEventInsurance(e: any) {
    this.handleFileUpload(e, "insurance", "insuracePreview");
  }

  fileChangeEventPermitYears(e: any) {
    this.handleFileUpload(e, "permitYears", "permit5yPreview");
  }

  fileChangeEventRoadTax(e: any) {
    this.handleFileUpload(e, "roadTax", "roadTexPreview");
  }

  fileChangeEventFitness(e: any) {
    this.handleFileUpload(e, "fitness", "fitnessPreview");
  }

  fileChangeEventOwnerPancard(e: any) {
    this.handleFileUpload(e, "ownerPancard", "ownerpanPreview");
  }

  fileChangeEventOwnerAadharcard(e: any) {
    this.handleFileUpload(e, "ownerAadharCard", "owneradharPreview");
  }

  fileChangeEventCancelledCheque(e: any) {
    this.handleFileUpload(e, "cancelledCheque", "cancelledChequePreview");
  }
}
